import { createEntityAdapter } from '@reduxjs/toolkit'

import { Run } from './models/Run'

export const runsAdapter = createEntityAdapter({
  selectId: (run: Run) => run.id,
})